import { useEffect, useRef, useState } from 'react';
import { prefersReducedMotion } from './landingHelpers';


// Цифры набегают, когда блок попадает в экран.
const CountUp = ({ value, suffix = '+', format = (shown) => shown }) => {
  const [ shown, setShown ] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
      setShown(value);
      return undefined;
    }

    let frame = 0;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();

        const start = performance.now();
        const tick = (now) => {
          const progress = Math.min(1, (now - start) / 900);
          // Замедление к концу, чтобы цифра доезжала, а не обрывалась.
          setShown(Math.round(value * (1 - Math.pow(1 - progress, 3))));
          if (progress < 1) frame = requestAnimationFrame(tick);
        };
        frame = requestAnimationFrame(tick);
      },
      { threshold: 0.4 }
    );

    observer.observe(node);
    return () => {
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
  }, [ value ]);

  return (
    <b ref={ref}>
      {format(shown)}
      {suffix}
    </b>
  );
};

export default CountUp;
